var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconMedicalAppLaptop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3h16.5v10.5H3.75Zm17.998 18H2.252A1.5 1.5 0 0 1 .91 18.829l1.836-3.671A3 3 0 0 1 5.429 13.5h13.142a3 3 0 0 1 2.683 1.658l1.836 3.671A1.5 1.5 0 0 1 21.748 21ZM10.5 18h3M12 6v4.5M9.75 8.25h4.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconMedicalAppLaptop);
export default __webpack_public_path__ + "static/media/streamline-icon-medical-app-laptop.81079efc.svg";
export { ForwardRef as ReactComponent };